import React from "react";
import styles from "./styles/download-button.module.scss";

type DownloadButtonProps = {
  onClick: () => void;
};

const DownloadButton = ({ onClick }: DownloadButtonProps) => {
  return (
    <button className={styles.container} onClick={() => onClick()}>
      Download
    </button>
  );
};

export default DownloadButton;
